import { WorksiteRecap, WorksiteRecapSkeleton } from '@components';
import { Container, Typography } from '@design-system';
import { useMyWorksiteResultsPage } from './useMyWorksiteResultsPage';

export const MyWorksiteResultsPage: React.FC = () => {
    const { worksitesWithData, isLoading, getGlobalStatus } = useMyWorksiteResultsPage();

    return (
        <Container>
            <Typography intrinsic="h2" defaultSpacing className="mb-medium-spacing-forced">
                Mes chantiers en cours
            </Typography>
            {isLoading ? (
                <WorksiteRecapSkeleton />
            ) : (
                <>
                    {worksitesWithData.map((worksiteData) => (
                        <WorksiteRecap
                            key={worksiteData.id}
                            worksite={{
                                id: worksiteData.progress.worksite.id_ext,
                                name: worksiteData.progress.worksite.name,
                                operator_name: worksiteData.info.operator_name,
                                apartments_count: worksiteData.info.apartments_count.toString()
                            }}
                            consumption={{
                                consumed: worksiteData.progress.global.consummed,
                                budget: worksiteData.progress.global.total,
                                tasks: [],
                                total: worksiteData.progress.global.total
                            }}
                            global={getGlobalStatus(worksiteData.progress)}
                            id={worksiteData.progress.worksite.id_ext}
                        />
                    ))}
                </>
            )}
        </Container>
    );
};
